<template>
  <div :id="componentId" class="spm6-title" :style="{ backgroundColor }">
    <div class="spm6-title-content">
      <span class="spm6-title-main" :style="{ color: titleColor }">{{ title }}</span>
      <div class="spm6-title-sub-row">
        <div class="spm6-title-line"></div>
        <span class="spm6-title-sub" :style="{ color: subTitleColor }">{{ subTitle }}</span>
        <div class="spm6-title-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileSpecialSixTitle',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_title'
    }
  },
  data() {
    return {
      title: '标题内容',
      titleColor: '#00000f',
      subTitle: 'CHINA BRAND',
      subTitleColor: 'rgba(52, 54, 56, 1)',
      backgroundColor: '#F3F3F3'
    }
  }
}
</script>

<style scoped>
.spm6-title {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm6-title-content {
  text-align: center;
}

.spm6-title-main {
  display: block;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 6px;
}

.spm6-title-sub-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spm6-title-line {
  width: 20px;
  height: 1px;
  background: #ccc;
}

.spm6-title-sub {
  font-size: 12px;
  letter-spacing: 1px;
}
</style>
